export default __webpack_public_path__ + "static/media/ListIcon.b5dfcdcc.svg";